<!--隐私协议-->
<template>
    <div class="reload-view">
        <div class="top-back">
            <div class="top-left">
                <img class="top-avatar" :src="avatar" alt="爱驿站">
            </div>
            <div class="top-right">
                <div class="code">{{nickname}}</div>
                <div class="top-text">{{ code }}</div>
            </div>

        </div>



        <div class="main">
            <div class="main-cat">
                收款账号
<!--                <div class="main-num" @click="setAccount">{{account}} <van-icon name="arrow" /></div>-->
                <div class="main-num" @click="setAccount">{{account}} <van-icon name="arrow" /></div>
            </div>
        </div>


        <div class="main" style="min-height: 400px">
            <div class="main-option">
                收益排行榜 [<span style="font-size: 13px">{{ rankYm }}</span>]
            </div>
            <div class="main-list">

                <div class="main-list-info" v-for="item in list" :key="item">
                    <div class="main-list-info-name">
                        {{item.nickname}}
                    </div>

                    <div class="main-list-info-text">
                        <span style="color: #F94B54">{{item.sum_revenue}}</span>
                    </div>

                    <div class="main-list-info-time">
                        累计邀请 {{ item.sum_bind_count }} 人
                    </div>
                </div>
                <div class="empty" v-show="emptyShow">暂无数据</div>
            </div>

        </div>
        <ReferralFooter index="3"/>
    </div>

</template>

<script setup>
import ReferralFooter from "@/components/referralFooter.vue";
import {useRouter} from "vue-router";
import {reactive, ref} from 'vue';
import ayzAjax from "@/plugins/axios";
import {showFailToast} from "vant";

const jwtInfo = JSON.parse(localStorage.getItem('jwtInfo'));
const userInfo = JSON.parse(localStorage.getItem('userInfo'));
const router = useRouter()
const nickname = ref(userInfo.nickname)
const avatar = ref(userInfo.avatar)
const code = ref(userInfo.referral_code)
const account = ref(userInfo.receive_account)
const list = reactive([])
const emptyShow = ref(false)
const rankYm = ref('')

const setAccount = async () => {
    await router.push({path: '/referral/account'});
}

try {
    ayzAjax.get('/referral/ranking_list',{
        headers: {
            'Authorization': 'Bearer ' + jwtInfo.access_token,
        }
    }).then((res) => {
        if (res.data.code === 4){
            return router.push({ path: '/referral/login'});
        }
        if(res.data.code !== 200){
            router.push({ path: '/referral/index'});
            return showFailToast(res.data.msg)
        }
        // console.log(res.data);
        res.data.data.ranking_list.forEach((item) => {
            list.push(item)
        });
        rankYm.value = res.data.data.ranking_ym;
        if (list.length === 0) {
            emptyShow.value = true
        }
    })
}catch(err) {
    console.log(err);
    showFailToast('网络错误,请稍后再试');
}

</script>

<style lang="scss" scoped>

.reload-view{
    background-color: #F6F6F6;
    text-align: left;
    .top-back{
        background-image: url('~@/assets/my-back.png');
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 150px;
        color: #FFFFFF;
        display: flex;
        .top-left{
            overflow: hidden;
            width: 70px;
            height: 70px;
            margin-top: 40px;
            margin-left: 24px;
            border-radius: 50%;
            border: #ffffff 3px solid;
            .top-avatar{
                width: 70px;
                height: 70px;
            }
        }
        .top-right{
            margin-top: 45px;
            .code{
                //padding-top: 30px;
                padding-left: 25px;
                font-weight: 600;
                font-size: 18px;
                color: #FFFFFF;
            }
            .top-text{
                margin-top: 10px;
                margin-left: 25px;
                margin-right: 25px;
                font-weight: 500;
                font-size: 13px;
                color: #FFFFFF;
            }
        }
    }
    .main{
        min-height: 60px;
        margin: 12px;
        background: #FFFFFF;
        border-radius: 17px 17px 17px 17px;
        .main-cat{
            padding-top: 18px;
            padding-left: 15px;
            padding-right: 25px;
            font-size: 15px;
            color: #161616;
            text-align: left;
            line-height: 25px;
            font-weight: 500;
            .main-num{
                float: right;
                width: 200px;
                height: 25px;
                font-weight: 500;
                font-size: 13px;
                text-align: right;
            }
        }
        .main-option{
            padding-top: 25px;
            margin-left: 15px;
            font-weight: 500;
            font-size: 15px;
            color: #222222;
            margin-bottom: 15px;
        }
        .main-list-info{
            margin-top: 2px;
            height: 40px;
            line-height: 40px;
            padding-left: 15px;
            font-size: 12px;
            text-align: center;
            .main-list-info-name{
                float: left;
                width: 100px;
                color: #222222;
                text-align: left;
            }
            .main-list-info-text{
                width: 120px;
                float: left;
                color: #161616;
                text-align: left;
            }
            .main-list-info-time{
                float: left;
                color: #161616;
                text-align: right;
            }
        }
    }
}
.empty{
    margin-top: 100px;
    width: 100%;
    height: 50px;
    color: #555555;
    font-size: 12px;
    text-align: center;
}

</style>
